import { useCart } from '../context/CartContext';

export default function Toast() {
  const { toast } = useCart();
  return (
    <div className={`toast ${toast.show ? 'show' : ''}`}>
      <span className="toast-icon">✅</span>
      <span>{toast.msg}</span>
    </div>
  );
}
